import { fileUpload, getRequest, postRequest } from './request'
// 获取设备列表
export function DeviceLists(params){
    return getRequest("/device/lists",
        params
 )
}
// 新增设备
export function deviceAdd(params){
  return postRequest("/device/add",
        params
  )
}
// 配置设备
export function deviceConfigure(params){
  return postRequest("/device/edit/configure",
        params
  )
}
// 商户-机构级联选项列表
export function institutionTreeList(params){
  return getRequest("/business/tree",
        params
  )
}
// 批量导入设备
export function importDevice(params){
  return fileUpload("/device/import",
        params
  )
}
// 批量导入设备
export function activeImportDevice(params){
  return fileUpload("/promotion/device/import",
        params
  )
}
export function userLists(params){
    return getRequest("/device/user/lists",
        params
 )
}
export function deviceDetail(params){
    return getRequest("/device/detail",
        params
 )
}
export function deviceRepairLogLists(params){
    return getRequest("/device/repairLog/lists",
        params
 )
}
export function deviceRepairLogAdd(params){
    return postRequest("/device/repairLog/add",
        params
 )
}
export function electricityLists(params){
    return getRequest("/device/electricity/lists",
        params
 )
}
export function deviceRepairLogDelete(params){
    return getRequest("/device/repairLog/delete",
        params
 )
}